(function() {
  var Service,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Service = App.loadClass('core::Angular/Service');

  exports.FieldsService = (function(superClass) {
    extend(FieldsService, superClass);

    function FieldsService(http, rootScope, zones1, q) {
      this.http = http;
      this.rootScope = rootScope;
      this.zones = zones1;
      this.q = q;
      this.mapZoneType = bind(this.mapZoneType, this);
      this.enableChildSteps = bind(this.enableChildSteps, this);
      this.fillZone = bind(this.fillZone, this);
      this.fillZones = bind(this.fillZones, this);
      this.formatDataForAllZones = bind(this.formatDataForAllZones, this);
      this.makeFeature = bind(this.makeFeature, this);
      this.hasFieldprintAccess = bind(this.hasFieldprintAccess, this);
      this.loadFieldById = bind(this.loadFieldById, this);
      this.cleanup = bind(this.cleanup, this);
      this.getProcessMode = bind(this.getProcessMode, this);
      this.getLayersId = bind(this.getLayersId, this);
      this.getGeojson = bind(this.getGeojson, this);
      this.setLayersId = bind(this.setLayersId, this);
      this.setYear = bind(this.setYear, this);
      this.setFieldsId = bind(this.setFieldsId, this);
      this.setFieldData = bind(this.setFieldData, this);
      this.setProcessMode = bind(this.setProcessMode, this);
      this.setLayerTitle = bind(this.setLayerTitle, this);
      this.setGeojson = bind(this.setGeojson, this);
      this.process_mode = 'zone-add';
    }

    FieldsService.prototype.all = function() {
      return this.http.post('backend/grower/fields/define/load-fields');
    };

    FieldsService.prototype.structureFieldsSavePostOptions = function(data) {
      var ref;
      return {
        farms_id: (data != null ? (ref = data.farm) != null ? ref.id : void 0 : void 0) != null ? data.farm.id : null,
        id: (data != null ? data.id : void 0) != null ? data.id : null,
        geom: data.geom,
        name: data.name,
        tillable_acres: data.area
      };
    };

    FieldsService.prototype.saveGeometry = function(options, api_data_token, year) {
      return this.http.post('backend/grower/fields/define/update-field-geometry', {
        options: this.structureFieldsSavePostOptions(options),
        api_data_token: api_data_token,
        year: year
      });
    };

    FieldsService.prototype.setGeojson = function(geojson) {
      this.geojson = geojson;
      return void 0;
    };

    FieldsService.prototype.setLayerTitle = function(layer_title) {
      this.layer_title = layer_title;
      return void 0;
    };

    FieldsService.prototype.setProcessMode = function(process_mode) {
      this.process_mode = process_mode;
      return void 0;
    };

    FieldsService.prototype.setFieldData = function(field_data) {
      this.field_data = field_data;
      return void 0;
    };

    FieldsService.prototype.setFieldsId = function(fields_id) {
      this.fields_id = fields_id;
      return void 0;
    };

    FieldsService.prototype.setYear = function(year1) {
      this.year = year1;
      return void 0;
    };

    FieldsService.prototype.setLayersId = function(layers_id) {
      this.layers_id = layers_id;
      return void 0;
    };

    FieldsService.prototype.getGeojson = function() {
      return this.geojson;
    };

    FieldsService.prototype.getFieldData = function() {
      if (this.field_data != null) {
        return this.field_data;
      } else {
        return null;
      }
    };

    FieldsService.prototype.getFieldsId = function() {
      if (this.fields_id != null) {
        return this.fields_id;
      } else {
        return null;
      }
    };

    FieldsService.prototype.getYear = function() {
      if (this.year != null) {
        return this.year;
      } else {
        return null;
      }
    };

    FieldsService.prototype.getLayersId = function() {
      return this.layers_id;
    };

    FieldsService.prototype.getProcessMode = function() {
      return this.process_mode;
    };

    FieldsService.prototype.cleanup = function() {
      this.setFieldData(null);
      this.setFieldsId(null);
      this.setYear(null);
      this.setLayersId(null);
      this.setLayerTitle(null);
      this.setGeojson(null);
      return this.process_mode = 'zone-add';
    };

    FieldsService.prototype.loadFieldById = function(id) {
      return this.http.post('backend/grower/fields/edit', {
        fields_id: id
      }).then((function(_this) {
        return function(response) {
          if (response.data.status.type === 'success') {
            return response.data.data;
          }
        };
      })(this));
    };

    FieldsService.prototype.hasFieldprintAccess = function() {
      return this.http.post('backend/grower/fields/fieldprint-access-check');
    };

    FieldsService.prototype.makeFeature = function(geometry, properties) {
      if (properties == null) {
        properties = {};
      }
      return {
        type: 'Feature',
        properties: properties,
        geometry: geometry
      };
    };

    FieldsService.prototype.formatDataForAllZones = function() {
      return this.loadFieldById(this.fields_id).then((function(_this) {
        return function(result) {
          var template;
          template = _this.fill(result.field, _this.getFieldData());
          template.boundary = _this.getGeojson();
          return template;
        };
      })(this));
    };

    FieldsService.prototype.load = function(cb, fill_zones, zone_id) {
      if (fill_zones == null) {
        fill_zones = false;
      }
      if (zone_id == null) {
        zone_id = false;
      }
      return this.loadFieldById(this.fields_id).then((function(_this) {
        return function(result) {
          var field, template, zones;
          zones = result.zones;
          field = result.field;
          template = _this.fill(field, _this.getFieldData());
          if (!fill_zones) {
            _this.setFieldData(template);
            cb(template);
          }
          if (fill_zones === 'single') {
            return _this.fillZone(zone_id, template, cb);
          }
        };
      })(this));
    };

    FieldsService.prototype.fill = function(old, neww) {
      var i, j, len, to_copy;
      to_copy = ['name', 'farms_id', 'id', 'boundary', 'has_fieldprint_access'];
      for (j = 0, len = to_copy.length; j < len; j++) {
        i = to_copy[j];
        neww[i] = old[i];
      }
      neww.boundary = this.makeFeature(JSON.parse(neww.boundary));
      neww.farm = {
        id: old.farms_id
      };
      return neww;
    };

    FieldsService.prototype.fillZones = function(zones, template, cb) {
      var id, j, len, promises, zoneLoadingCallback;
      promises = [];
      zoneLoadingCallback = (function(_this) {
        return function(response) {
          var zone, zone_property;
          if (response.data.status.type === 'success') {
            zone = response.data.data;
            zone_property = _this.mapZoneType(zone.zone_type);
            zone.loaded_zones = zone.areas;
            zone.zones = [];
            zone.editing = true;
            _this.enableChildSteps(template, zone.zone_type);
            return template.zones[zone_property] = zone;
          }
        };
      })(this);
      for (j = 0, len = zones.length; j < len; j++) {
        id = zones[j];
        promises.push(this.zones.load(id, zoneLoadingCallback));
      }
      return this.q.all(promises).then((function(_this) {
        return function() {
          _this.setFieldData(template);
          return cb(template);
        };
      })(this));
    };

    FieldsService.prototype.fillZone = function(zone_id, template, cb) {
      return this.fillZones([zone_id], template, cb);
    };

    FieldsService.prototype.enableChildSteps = function(template, zone_type) {
      var j, len, ref, step;
      ref = template.zone_steps;
      for (j = 0, len = ref.length; j < len; j++) {
        step = ref[j];
        if (step.name === zone_type) {
          step.enabled = true;
          return;
        }
      }
    };

    FieldsService.prototype.mapZoneType = function(type) {
      if (type.toLowerCase().indexOf('productivity') > -1) {
        return 'productivity';
      }
      if (type === 'Irrigation') {
        return 'irrigation';
      }
      if (type === 'Previous Crop') {
        return 'previous-crop';
      }
    };

    return FieldsService;

  })(Service);

}).call(this);
